var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecureContract = function SvgSecureContract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#F0EDED",
    rx: 32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#secure-contract_svg__a)",
    rx: 32
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#secure-contract_svg__b)",
    rx: 32
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#secure-contract_svg__c)",
    fillOpacity: 0.63,
    rx: 32
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#fff",
    fillOpacity: 0.33,
    rx: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.982 30.763a1.25 1.25 0 0 1 1.837 1.695l-3.961 4.291a2.25 2.25 0 0 1-3.244.064l-1.987-1.986a1.25 1.25 0 0 1 1.768-1.767l1.802 1.801z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M34.334 14.5a.4.4 0 0 1 .399.4v7.791c0 1.234 1.045 2.234 2.334 2.234h8.155a.4.4 0 0 1 .4.4v21.94c0 1.234-1.045 2.235-2.333 2.235H20.733c-1.289 0-2.333-1-2.333-2.234V16.733c0-1.233 1.045-2.233 2.333-2.233h13.6Zm-1.479 11.71a1.355 1.355 0 0 0-1.687 0c-1.492 1.23-3.65 2.13-5.166 2.438-.542.11-.99.564-.984 1.117.027 2.113.142 5.18.46 7.33.353 2.386 4.076 4.423 6.188 5.271.223.09.468.09.69 0 2.113-.848 5.835-2.885 6.188-5.27.319-2.15.434-5.218.46-7.331.007-.553-.442-1.006-.983-1.117-1.517-.309-3.675-1.208-5.166-2.438",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.289 15.065a.4.4 0 0 1 .682-.283l7.968 7.968a.4.4 0 0 1-.282.683h-6.813a1.556 1.556 0 0 1-1.555-1.556z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "secure-contract_svg__a",
    x1: -61.464,
    x2: 212.244,
    y1: 32,
    y2: 31.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895FFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9E7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "secure-contract_svg__b",
    x1: 6.624,
    x2: 61.947,
    y1: 64,
    y2: 64.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#3682FA",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "secure-contract_svg__c",
    x1: -15.203,
    x2: 106.834,
    y1: 31.886,
    y2: 31.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgSecureContract;